// src/ui-kit/SummernoteEditor/SummernoteEditor.tsx
import {useEffect, useRef} from 'react'
import $ from 'jquery'
import 'summernote/dist/summernote-lite.css'
import 'summernote/dist/summernote-lite.js'

type Props = {
  value?: string
  onChange?: (html: string) => void
}

export default function SummernoteEditor({value = '', onChange}: Props) {
  const editorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!editorRef.current) return

    const $editor = $(editorRef.current)

    $editor.summernote({
      height: 300,
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link', 'picture', 'table']],
        ['view', ['codeview', 'help']],
      ],
      callbacks: {
        onChange: (contents: string) => {
          onChange?.(contents)
        },
      },
    })

    // set initial value
    $editor.summernote('code', value)

    return () => {
      $editor.summernote('destroy')
    }
  }, [])

  // keep editor in sync when value changes (edit mode)
  useEffect(() => {
    if (!editorRef.current) return

    const $editor = $(editorRef.current)
    const current = $editor.summernote('code') as unknown as string

    if (value !== current) {
      $editor.summernote('code', value)
    }
  }, [value])

  return <div ref={editorRef} />
}
